import { array } from "../../../shared/src/codecs/types/array";
import { form } from "../../../shared/src/codecs/types/form";
import { required } from "../../../shared/src/codecs/types/required";
import { uuid } from "../../../shared/src/codecs/types/uuid";
import { TTypeOfCodec, TTypeOfNewDefault } from "../../../shared/src/codecs/codec";
import { CasePropertyReferredDocument } from "../CasePropertyReferredDocument";

export const CasePropertyReferredDocumentsForm = form(
    required({
        id: uuid(),
    }),
    required({
        referred_documents: array(CasePropertyReferredDocument),
    }),
);
export type TCasePropertyReferredDocumentsFormCodec = typeof CasePropertyReferredDocumentsForm;
export type TCasePropertyReferredDocumentsForm = TTypeOfCodec<TCasePropertyReferredDocumentsFormCodec>;
export type TCasePropertyReferredDocumentsFormNewDefault = TTypeOfNewDefault<TCasePropertyReferredDocumentsFormCodec>;
